import React, { useEffect, useState } from "react";
import { Button, Card, Col, Descriptions, Divider, Form, Select, Space, Typography } from "antd";
import { UserService } from "../../../Services/Manage/UserService";
import { useNavigate } from "react-router-dom";
import Permissions from "../../../components/Permission/Permissions";
import { PermissionService } from "../../../Services/Permission/PermissionService";

const { Option, OptGroup } = Select;

const ManagePermission = () => {
    const [users, setUsers] = useState([]);
    const [groupedUsers, setGroupedUsers] = useState({});
    const [selectedUsers, setSelectedUsers] = useState([]);
    const navigate = useNavigate();

    const getAllUser = async () => {
        try {
            const response = await UserService.getAllUsers();
            if (response?.status && Array.isArray(response.data)) {
                const activeUsers = response.data.filter(user => user.status === "Active");

                setUsers(activeUsers);

                const grouped = activeUsers.reduce((acc, user) => {
                    const deptId = user.department_id || "no-dept";
                    const deptName = user.department_name || "No Department";

                    if (!acc[deptId]) {
                        acc[deptId] = { name: deptName, users: [] };
                    }
                    acc[deptId].users.push(user);
                    return acc;
                }, {});

                setGroupedUsers(grouped);
            }
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    };

    useEffect(() => {
        getAllUser();
    }, []);

    const handleGetUserData = async(selectedIds) => {
        console.log(selectedIds);
        
        const selectedArray = Array.isArray(selectedIds) ? selectedIds : [selectedIds];
        const selectedFullData = users.filter((user) => selectedArray.includes(user.user_id));
        setSelectedUsers(selectedFullData);

        try {
            const request = await PermissionService.getPermissionDetailsById(selectedIds);
            console.log(request);
            
        } catch (error) {
            
        }
    };

    return (
        <Space direction="vertical" size="small" style={{ width: "100%" }}>
            <Card title={<Typography.Title level={4}>Manage Permission</Typography.Title>}
                 extra={
                    <Button size="large" onClick={()=> navigate('/manage-user')}>Create User / Employee</Button>
                }
            >
                <div style={{ display: "flex", gap: 25 }}>
                    <div style={{ flex: 2 }}>
                        <Form layout="vertical">
                            <Form.Item label="Select user">
                                <Select
                                    showSearch
                                    allowClear
                                    placeholder="Select users"
                                    size="large"
                                    style={{ minWidth: "50%", maxWidth: "100%" }}
                                    onChange={handleGetUserData}
                                    optionFilterProp="children"
                                    filterOption={(input, option) => {
                                        const { name, user_id, phone, department } = option?.user || {};
                                        const searchText = input.toLowerCase();
                                        return (
                                            name?.toLowerCase().includes(searchText) ||
                                            user_id?.toLowerCase().includes(searchText) ||
                                            phone?.toLowerCase().includes(searchText) ||
                                            department?.toLowerCase().includes(searchText)
                                        );
                                    }}
                                >
                                    {Object.entries(groupedUsers).map(([deptId, deptData]) => (
                                        <OptGroup key={deptId} label={`Department: ${deptData.name}`}>
                                            {deptData.users.map((item) => (
                                                <Option
                                                    key={item.user_id}
                                                    value={item.user_id}
                                                    user={{
                                                        name: item.name,
                                                        user_id: item.user_id,
                                                        phone: item.phone,
                                                        department: item.department_name,
                                                    }}
                                                >
                                                    {item.name} ({item.user_id}) — Ph:{item.phone}
                                                </Option>
                                            ))}
                                        </OptGroup>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Form>
                    </div>

                    <Divider type="vertical" style={{ height: "auto" }} />

                    <div style={{ flex: 3, display: "flex", flexWrap: "wrap", gap: 20 }}>
                        {selectedUsers.map((item) => (
                            <Descriptions 
                                key={item.user_id}
                                column={1}
                                size="small"
                                labelStyle={{ fontWeight: 600 }}
                                style={{
                                    borderRadius: 8,
                                    // padding: 12,
                                    minWidth: '100%',
                                }}
                            >
                                <Descriptions.Item label="Name">
                                    <strong>{item.name}</strong>
                                </Descriptions.Item>
                                <Descriptions.Item label="User ID">{item.user_id}</Descriptions.Item>
                                <Descriptions.Item label="Department">{item.department_name}</Descriptions.Item>
                                <Descriptions.Item label="Phone">Ph: {item.phone}</Descriptions.Item>
                                <Descriptions.Item label="Role">
                                    <Typography.Text type="success">{item.role}</Typography.Text>
                                </Descriptions.Item>
                            </Descriptions>
                        ))}
                    </div>
                </div>
            </Card>

            <Permissions selectedUsers={selectedUsers} />
        </Space>
    );
};

export default ManagePermission;
